import {KTIcon, KTSVG} from '../../../../../_metronic/helpers'
import React, {useEffect, useMemo, useRef, useState} from 'react'
import Swal from 'sweetalert2'
import {
  cancelPieces,
  createCommentaireClientDemande,
  getAllDemandeDevis,
  getAllTypeLibelleDemande,
  getClientAdresses,
  getLibelleDemandePiece,
  getTypePieceStockValue,
  PaiementMontantSociete,
  validateSuggestion,
} from '../../../../../components/requests'
import {Link, useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'
import {useLocation} from 'react-router'
import {Tooltip} from 'react-tooltip'
import MotifModal from '../Televendeur/MotifModal'
import {Modal} from 'bootstrap'
import {ModeleCommentaireClientDemande, ModeleDemandeDevis} from '../../../../../components/Models'
import {useAuth} from '../../../../modules/auth'
import {DetailsPieceModal} from '../../../suggestion/Components/DetailsPieceModal'
import ClientInfos from '../ClientInfos'
import ShopDevis from './devis/ShopDevis'
import ShopLibelle from './ShopLibelle'
import ShopPiece from './ShopPiece'
import FinalAdresseClient from '../Televendeur/FinalAdresseClient'
import {LoadingData} from '../../../../../components/LoadingData'
import ClientMoreInfos from '../Televendeur/ClientMoreInfos'
import DemandeInfos from '../DemandeInfos'
import PaymentResumeModal from '../../../suggestion/Components/PaymentResumeModal'
import {
  computeSource,
  getNumDemandeDevis,
  transformToValueLabel,
} from '../../../../../components/helpers'
import {offset, shift} from '@floating-ui/dom'
import Select from 'react-select'
import moment from 'moment/moment'
import isEqual from 'lodash/isEqual'

const ShopModal = (props: any) => {
  const {
    panier,
    setPanier,
    clientId,
    demandeId,
    redirectToClientDemande,
    demandeClient,
    setDemandeClient,
    panierFiltered,
    loading,
    setPiecesProps,
    idPiecePropose,
    pieces,
    setPieces,
    dataClientInfos,
    otherData,
    loadingCLientInfo,
    isProspect,
    totalPanier,
    piecesInStockArr,
    setPiecesInStockArr,
    piecesInStockArrTemp,
    redirectDemandeListPage,
    loadingPanier,
    filters,
    fromListePiece,
    panierByStatus,
    setPanierByStatus,
    setFromListePiece,
    fromListePieceStock,
    provenances,
    updatedFinalAdresseLivInfo,
    setUpdatedFinalAdresseLivInfo,
    updatedFinalAdresseFactInfo,
    setUpdatedFinalAdresseFactInfo,
    adresseFacturation,
    errorsFac,
    setErrorsFac,
    errorsLiv,
    setErrorsLIv,
    requierdFieldFac,
    requierdFieldLiv,
    isConfirmEdit,
    contactedBy,
    setIsEdit,
    fromListDemande,
    clientDemandeStatus,
    clientAdressesFacLiv,
    contactedByBloc,
    setContactedByBloc,
    piecePropData,
    groupeClientLoader,
    isLoadingProvenance = false,
    refetchClientAdresses = () => {},
    retraitDepot = false,
    setRetraitDepot = () => {},
    initialPieces = [],
    setInitialPieces = () => {},
    totalLibelle = 0,
    setTotalLibelle = () => {},
    getAdresseRetraitDepot = () => {},
    loadingDepot = false,
    adresseDepots,
    commentaireInterne,
    setCommentaireInterne,
    setIsEditPanier,
    livraisonSelectedValue,
    setLivraisonSelectedValue,
    facturationSelectedValue,
    setFacturationSelectedValue,
    clientAdresseData,
    setReloadLibelle = () => {},
    reloadLibelle = false,
    clientContacts,
    getDemandeProp = () => {},
    setUpdatedAdresseLivInfo,
    setUpdatedAdresseFactInfo,
  } = props
  const navigate = useNavigate()
  const location = useLocation()
  const modalRef = useRef<HTMLDivElement | null>(null)
  const [selectedMotif, setSelectedMotif] = useState<{value: number; label: string}>()
  const [statutsLocaux, setStatutsLocaux] = useState<Record<number, string>>({})
  const [dateAnnulationLocaux, setDateAnnulationLocaux] = useState<Record<number, string>>({})
  const [isAllSelected, setIsAllSelected] = useState(false)
  const [showAllSelect, setShowAllSelect] = useState<boolean>(false)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [piecesProposeesModifiees, setPiecesProposesModifiees] = useState<any[]>([])
  const [piecesProposeesChecked, setPiecesProposeesChecked] = useState<any[]>([])
  const [loadingRenvoiPropos, setLoadingRenvoiPropos] = useState(false)
  const [nouveauPanier, setNouveauPanier] = useState([])
  const [disableBtn, setDisableBtn] = useState<boolean>(false)
  const {currentUser} = useAuth()
  const [idsAnnules, setIdsAnnules] = useState<any[]>([])
  const [totalPropose, setTotalPropose] = useState<number>(0)
  const [totalFraisPort, setTotalFraisPort] = useState<number>(0)
  const [totalProposeHT, setTotalProposeHT] = useState<number>(0)
  const [totalProposeTTC, setTotalProposeTTC] = useState<number>(0)
  const [loadStock, setLoadStock] = useState<boolean>(false)
  const [dataToDisplay, setDataToDisplay] = useState<any>()
  const [displayBasket, setDisplayBasket] = useState<boolean>(props?.displayBasketBtn ?? true)
  const [allTypeLibelleDmd, setAllTypeLibelleDmd] = useState<Array<any>>([])
  const [switchPiece, setSwitchPiece] = useState<boolean>(true)

  const [libelleForm, setLibelleForm] = useState<any>({
    id: '',
    libelle: '',
    commentaire: '',
    prixUnitaire: '',
    quantite: '',
    idTypeLibelleDemande: '',
  })
  // Liste des libellés dans le panier
  const [libelleList, setLibelleList] = useState<any>([])
  const [filteredLibelle, setFilteredLibelle] = useState<any>([])
  const initialLibellesRef = useRef(null)
  const [hasLibelleChanged, setHasLibelleChanged] = useState<boolean>(false)
  // Si toutes les pièces sont proposées, et que les libellées sont modifiés,
  // Permettre la renvoi de la proposition. Autrement, c'est le rôle de "Renvois le devis" d'envoyer les libellés
  const haveUpdatedLibelle = panier
    && panier?.length > 0
    && panier?.every((item) => item?.statut === "PROPO")
    && hasLibelleChanged

  const [addressDepotFormat, setAddressDepotFormat] = useState<any>([])
  const [piecePanierFormat, setPiecePanierFormat] = useState<any>([])
  const [associations, setAssociations] = useState({}) // association des pièces et du retrait dépot
  const [selectedPiece, setSelectedPiece] = useState<any>({value: 'tous', label: 'Tous'})
  const [selectedDepot, setSelectedDepot] = useState<any>({})
  // Vérification si c'est un retrait dépôt et que l'adresse de dépôt selectionnée n'est pas la valeur vide selectionnée par défaut
  const haveNoSelectedDepot = (retraitDepot && selectedDepot?.value === null)

  const [spinnerLibelle, setSpinnerLibelle] = useState<boolean>(false)
  const [spinnerLibelleDiplay, setSpinnerLibelleDisplay] = useState<boolean>(false)
  const [showForm, setShowForm] = useState<boolean>(false)
  const [totalLibelleTTC, setTotalLibelleTTC] = useState<number>(0)
  const [fullLibelleData, setFullLibelleData] = useState<boolean>(false)
  const totauxDevis = useMemo(
    () =>
      Number(retraitDepot !== undefined && retraitDepot ? 0 : totalLibelle) +
      Number(totalProposeHT),
    [retraitDepot, totalLibelle, totalProposeHT]
  )
  const totauxDevisTTC = useMemo(
    () =>
      Number(retraitDepot !== undefined && retraitDepot ? 0 : totalLibelleTTC) +
      Number(totalProposeTTC),
    [retraitDepot, totalLibelleTTC, totalProposeTTC]
  )
  const [onResendPropo, setOnResendPropo] = useState<boolean>(false)
  const [clientAdresses, setClientAdresses] = useState<any | null>(null)
  const [loadingAdresse, setLoadingAdresse] = useState<boolean>(false)
  const [isAdresseUpdated, setIsAdresseUpdated] = useState<boolean>(false)
  const [filteredAdresseFacturation, setFilteredAdresseFacturation] = useState<any>(null)
  const mergedOtherData = {...otherData, contactedBy: contactedBy} // imbriqué contactedBy dans otherData
  const [showMoreClientInfo, setShowMoreClientInfo] = useState<boolean>(false)
  const [displayHistory, setDisplayHistory] = useState<boolean>(false)
  const [historiqueDevis, setDevisHistorique] = useState<ModeleDemandeDevis[]>([])
  const [loadingHistoryDevis, setLoadingHistoryDevis] = useState<boolean>(true)
  const [openModalDevis, setOpenModalDevis] = useState<any>(false)
  const [mailContent, setMailContent] = useState<any>({destinataire: '', destinataireCc: '', objet: '', message: ''})
  const openPaymentModal = useRef<HTMLButtonElement>(null)
  const [pieceCheckedObj, setPieceCheckedObj] = useState<any>([])
  const [checkedPieces, setCheckedPieces] = useState<number[]>([])
  const [total, setTotal] = useState<{
    piece: number | null
    transport: number | null
  }>({
    piece: null,
    transport: null,
  })
  const [selectedDepotsByPiece, setSelectedDepotsByPiece] = useState<Record<string, string>>({})
  // Ref qui garde les paramètres de feedback en mémoire
  const pendingValidationParams = useRef<{
    ids: any
    status: boolean
    idMotif: number | null
    isProspect: boolean
    nouveauStatut: any
    adresseFactToSend: any
    adresseLivToSend: any
  } | null>(null)
  const [clientParametrage, setClientParametrage] = useState<any>(null)
  const [montants, setMontants] = useState<PaiementMontantSociete[]>([])
  const [sourceDevis, setSourceDevis] = useState<string | null>(null)
  const [activeHistorique, setActiveHistorique] = useState<number>(0)
  const utilisateurAssigne = displayHistory ? historiqueDevis?.[activeHistorique]?.utilisateurAssigne : currentUser
  const [selectedOption, setSelectedOption] = useState('')
  const [filtrePanier, setFiltrePanier] = useState<any>([{value: 'Tous', label: 'Tous'}, {value: 'En cours', label: 'En cours'}])
  const [activeFiltrePanier, setActiveFiltrePanier] = useState<any>(filtrePanier?.[0])
  const [filteredPanier, setFilteredPanier] = useState<any>([])
  const [showEditForm, setShowEditForm] = useState<number | null>(null)

  const calculerTotal = (panier, titre: string = '') => {
    const sommeTotalHT = panier
      .filter((item) => item?.statut === 'PROPO' || item?.statut === 'A_PROPO')
      .reduce((acc, item) => acc + (Number(parseFloat(item.prixVenteProposeeHt)) || 0), 0)
    const sommeFaisDePortHT = panier
      .filter((item) => item?.statut === 'PROPO' || item?.statut === 'A_PROPO')
      .reduce((acc, item) => acc + (Number(parseFloat(item.fraisDePort)) || 0), 0)
    const sommeTotalTTC = panier
      .filter((item) => item?.statut === 'PROPO' || item?.statut === 'A_PROPO')
      .reduce((acc, item) => acc + (Number(parseFloat(item.prixVenteProposeeTtc)) || 0), 0)
    // frais de port toujours 20%
    const sommeFaisDePortTTC = panier
      .filter((item) => item?.statut === 'PROPO' || item?.statut === 'A_PROPO')
      .reduce((acc, item) => acc + (Number(parseFloat(item?.fraisDePort) * (1 + 20 / 100)) || 0), 0)

    // pour calculer et mettre à jour la valeur sur le total proposé à afficher
    if (titre === 'TotalPropose') return sommeTotalHT

    // pour calculer et mettre à jour la valeur sur le total proposé à afficher
    if (titre === 'FraisPort') return sommeFaisDePortHT

    // pour calculer et mettre à jour le total HT + frais de port HT
    if (titre === 'TotalProposeHT') return sommeTotalHT + sommeFaisDePortHT

    // pour calculer et mettre à jour le total TTC + frais de port en TTC
    if (titre === 'TotalProposeTTC') return sommeTotalTTC + sommeFaisDePortTTC
  }

  // Prendre tous les devis envoyés dans la demande
  useEffect(() => {
    if (isModalOpen && demandeId) {
      setLoadingHistoryDevis(true)
      getAllDemandeDevis(demandeId)
        .then((res) => {
          if (res?.status === 200 && res?.data !== undefined) {
            setDevisHistorique(res?.data)
          }
        })
        .catch(() => console.log('Erreur'))
        .finally(() => setLoadingHistoryDevis(false))
    }
  }, [demandeId, isModalOpen])

  useEffect(() => {
    const modifiees = [
      ...checkedPieces,
      ...piecesProposeesModifiees.map((piece) => piece.idPiecePropose),
    ]
    const uniqueCheckedPieces = Array.from(new Set(modifiees))
    setCheckedPieces(uniqueCheckedPieces)
  }, [piecesProposeesModifiees])

  // const prevPiecesProposeesModifieesRef = useRef<any>([]);
  // useEffect(() => {
  //   const prevIds = prevPiecesProposeesModifieesRef.current.map((p) => p.idPiecePropose);
  //   const currentIds = piecesProposeesModifiees.map((p) => p.idPiecePropose);
  //   const idsARetirer = prevIds.filter((id) => !currentIds.includes(id));
  //   setCheckedPieces((prevChecked) => {
  //     const sansReset = prevChecked.filter((id) => !idsARetirer.includes(id));
  //     return Array.from(new Set([...sansReset, ...currentIds]));
  //   });
  //   prevPiecesProposeesModifieesRef.current = piecesProposeesModifiees;
  // }, [piecesProposeesModifiees]);

  // Pour obtenir le stock de chaque type pièce apres validation ou notification du panier et pour controller l'arret de la requete
  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    if (setPiecesProps && loadStock) {
      pieces.forEach(async (demande, index) => {
        let stock = 0
        let ref = demande.refConst ?? ''
        let isHorsType = demande.clientDemandeImmat.vehiculeHorsType

        if (demande?.typePiece?.id) {
          await getTypePieceStockValue(
            demande.typePiece.id,
            ref,
            isHorsType !== null ? '' : demande.marque,
            isHorsType !== null ? '' : demande.modele,
            signal
          ).then((res) => (stock = res?.data[0]))
        }

        setPiecesProps((prevTypePiece) => {
          const updatedTypePiece = [...prevTypePiece]
          updatedTypePiece[index] = {...updatedTypePiece[index], stock}
          return updatedTypePiece
        })
      })
    }

    return () => controller.abort()
  }, [loadStock, setLoadStock])

  const handleCancelRenvoiPropos = () => {
    if (!initialPieces || initialPieces.length === 0) return

    const resetPanier = panier.map((piece) => {
      const initial = initialPieces.find((p) => p.id === piece.id)
      if (initial) {
        const fraisDePort = initial.fraisDePort
        const fraisDePortInitial = initial.fraisDePortInitial

        const prixReferentielHt = initial.prixReferentielHt
        const prixReferentielTtc = initial.prixReferentielTtc
        const prixVenteProposeeHt = initial.prixVenteProposeeHt
        const prixVenteProposeeTtc = initial.prixVenteProposeeTtc

        const tauxRemise = parseFloat(Number(initial.tauxRemise).toFixed(2))
        const montantRemise = parseFloat(Number(initial.montantRemise).toFixed(2))
        return {
          ...piece,
          fraisDePort,
          fraisDePortInitial,
          prixReferentielHt,
          prixReferentielTtc,
          prixVenteProposeeHt,
          prixVenteProposeeTtc,
          montantRemise,
          tauxRemise,
        }
      }
      return piece
    })

    if (panierFiltered) panierFiltered(resetPanier)
    if (setPanier) setPanier(resetPanier)
    setPiecesProposesModifiees([])
    setCheckedPieces([])
    setPiecesProposeesChecked([])
    toast.info('Modifications annulées')
  }

  // verification si la quantité max est atteint par rapport au total piece acceptee
  const validCountByDemPiece = panier.reduce((acc, art) => {
    const demPiId = art.idCLientDemandePiece
    const isValid = art.isAccepted || art.isAcceptedBlocked
    acc[demPiId] = (acc[demPiId] ?? 0) + (isValid ? 1 : 0)
    return acc
  }, {} as Record<number, number>)

  const checkDisponibilite = () => {
    const updated = panier.map((pan) => {
      let isDepasse = false
      const dateProposition = new Date(pan.dateProposition)
      if (pan.heureDisponibilite !== null) {
        const dateLimite = new Date(
          dateProposition.getTime() + pan.heureDisponibilite * 60 * 60 * 1000
        )
        isDepasse = new Date() > dateLimite
      } else {
        isDepasse = false
      }

      return {
        ...pan,
        isDepasse,
        heureDisponibilite: pan.heureDisponibilite,
        isQuantityReached: validCountByDemPiece[pan.idCLientDemandePiece] >= pan.pieceQuantity,
      }
    })

    setNouveauPanier(updated)
    // setPanier(updated)
  }

  const statutLabels = {
    A_PROPO: 'À proposer',
    PROPO: 'Proposée',
    ASSIG: 'Assignée',
    ACCEP: 'Acceptée',
    REFUS: 'Refusée',
    CLOTP: 'Clôturée positive',
    CLOTN: 'Clôturée négative',
    BLOQU: 'Acceptée bloquée',
    CANCE: 'Annulée',
    ECHEC: 'Acceptée indisponible'
  }

  useEffect(() => {
    checkDisponibilite() // initial

    const interval = setInterval(checkDisponibilite, 360 * 10000) // toutes les 60 mins

    return () => clearInterval(interval)
  }, [panier])

  // Mise à jour des données du filtre du panier
  useEffect(() => {
    if (panier?.length > 0) {
      setFiltrePanier((prev) => {
        const options = [
          ...prev,
          ...(historiqueDevis?.map((item) => ({
            value: item?.id,
            label: item?.nomFichier ? item?.nomFichier.replace("DEV", "DEV-").replace(".pdf", "") : '',
            dateCreation: item?.dateCreation,
          })) ?? []),
        ];

        return Array.from(
          new Map(
            options
              .filter((item) => item.value)
              .map((item) => [item.value, item])
          ).values()
        );
      });
    }
  }, [historiqueDevis]);

  // Gestion des input requis vide (facturation)
  const validateFacErrors = () => {
    const newErrors = {}
    requierdFieldFac?.forEach((field) => {
      if (!updatedFinalAdresseFactInfo[field]) {
        newErrors[field] = true
      }
    })

    Object.keys(newErrors).length > 0 &&
      toast.error('Veuillez compléter les adresses de facturation requises')
    setErrorsFac(newErrors)
    return Object.keys(newErrors).length === 0
  }

  // Gestion des input requis vide (livraison)
  // Ne pas vérifier erreur adresse Liv si retraitDepot
  const validateLivErrors = () => {
    const newErrors = {}

    if (!retraitDepot) {
      requierdFieldLiv.forEach((field) => {
        if (!updatedFinalAdresseLivInfo[field]) {
          newErrors[field] = true
        }
      })

      Object.keys(newErrors).length > 0 &&
        toast.error('Veuillez compléter les adresses de livraison requises')
    }

    setErrorsLIv(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const checkAllFieldError = () => {
    const facValid = validateFacErrors()
    const livValid = validateLivErrors()
    return facValid && livValid
  }

  const feedBackClient = async (ids: any, status: boolean, idMotif: number | null) => {
    if (!checkAllFieldError()) return

    let nouveauStatut: string = ''
    if (isProspect && status) {
      nouveauStatut = 'BLOQU'
    } else {
      nouveauStatut = status ? 'ACCEP' : 'REFUS'
    }
    let hasExceeded = false
    let exceededMessages: string[] = []
    if (panier.length > 0) {
      const typePieceMap = new Map<
        number,
        {
          clientDemandePieceId: number
          selectedCount: number
          quantity: number
          nomTypePiece: string
        }
      >()
      for (const piece of panier) {
        if (!ids.includes(piece.idPiecePropose)) continue

        const existing = typePieceMap.get(piece.idCLientDemandePiece)

        if (existing) {
          existing.selectedCount += 1
        } else {
          const quantityOfPieces = pieces.filter((p) => {
            return piece.idCLientDemandePiece === p.id
          })

          typePieceMap.set(piece.idCLientDemandePiece, {
            clientDemandePieceId: piece.idCLientDemandePiece,
            selectedCount: 1,
            quantity: quantityOfPieces[0]?.quantite,
            nomTypePiece: piece.nomTypePiece,
          })
        }
      }

      Array.from(typePieceMap.values()).forEach((value) => {
        const {selectedCount, clientDemandePieceId, quantity, nomTypePiece} = value

        const total = selectedCount + validCountByDemPiece[clientDemandePieceId]

        if (total > quantity) {
          exceededMessages.push(`
            <b>${nomTypePiece}</b> : demandé = ${quantity}, sélectionné = ${selectedCount}
            ${
              validCountByDemPiece[clientDemandePieceId] > 0
                ? ', déjà accepté : ' + validCountByDemPiece[clientDemandePieceId]
                : ''
            }
          `)
        }
      })

      if (exceededMessages.length > 0) {
        hasExceeded = true

        const listHtml = exceededMessages
          .map((msg) => `<li style='margin-bottom: 10px'>${msg}</li>`)
          .join('')

        const result = await Swal.fire({
          titleText: `La quantité demandée a été dépassée pour ${
            exceededMessages.length > 1
              ? 'les types de pièces suivants'
              : 'le type de pièce suivant'
          } : `,
          html: `
              <ul style="text-align: left;">
                ${listHtml}
              </ul>
          `,
          icon: 'error',
          showCancelButton: true,
          confirmButtonText: 'Confirmer',
          cancelButtonText: 'Modifier la sélection',
          confirmButtonColor: '#1BC5BD',
          cancelButtonColor: '#F64E60',
          width: '900px',
        })
        // NB : la validation n'est pas bloqué meme si la quantité demandé a été dépassée
        // et si "confirmer" => la validation passe
        if (result.isConfirmed) {
          hasExceeded = false
        }
      }
    }

    if (!hasExceeded) {
      const adresseFactToSend = {
        ...updatedFinalAdresseFactInfo,
      }

      const adresseLivToSend = {
        ...updatedFinalAdresseLivInfo,
      }

      if (adresseFactToSend.id === adresseLivToSend.id) {
        if (adresseFactToSend.edited) {
          adresseFactToSend.id = ''
        }

        if (adresseLivToSend.edited) {
          adresseLivToSend.id = ''
        }
      }

      pendingValidationParams.current = {
        ids,
        status,
        idMotif,
        isProspect,
        nouveauStatut,
        adresseFactToSend,
        adresseLivToSend,
      }

      if (status) {
        // Cas acceptation "Ouverture modal de paiement"
        openPaymentModal?.current?.click()
      } else {
        // Cas refus
        setDisableBtn(true)

        suggestionValidation(
          ids,
          status,
          idMotif,
          isProspect,
          nouveauStatut,
          adresseLivToSend,
          adresseFactToSend,
          commentaireInterne
        )
      }
    }
  }

  const handlePaiementReussi = async (paymentIntentIds: string[]) => {
    const params = pendingValidationParams.current

    if (!params) return
    const {ids, status, idMotif, isProspect, nouveauStatut, adresseFactToSend, adresseLivToSend} =
      params

    suggestionValidation(
      ids,
      status,
      idMotif,
      isProspect,
      nouveauStatut,
      adresseLivToSend,
      adresseFactToSend,
      commentaireInterne,
      paymentIntentIds
    )
  }

  const suggestionValidation = async (
    ids: any,
    status: boolean,
    idMotif: number | null,
    isProspect: boolean,
    nouveauStatut: any,
    adresseLivToSend: any,
    adresseFactToSend: any,
    commentaireInterne: string,
    paymentIntentIds: string[] = []
  ) => {
    const idToastValidate = toast.loading('Validation en cours...')

    // const montantAPayer = montants.length
    //   ? montants.reduce((somme, montant) => somme + (montant?.montantTtc ?? 0), 0)
    //   : (total?.piece ?? 0) + (total?.transport ?? 0)

    let montantAPayer = 0
    if (retraitDepot) {
      //si retrait dépot y a pas de transports
      montantAPayer = montants?.length
        ? montants?.reduce((somme, montant) => somme + (montant?.montantTtc ?? 0), 0)
        : total?.piece ?? 0
    } else {
      montantAPayer = montants?.length
        ? montants?.reduce((somme, montant) => somme + (montant?.montantTtc ?? 0), 0)
        : (total?.piece ?? 0) + (total?.transport ?? 0)
    }

    const lastObjectDemandeDevis = historiqueDevis[0]?.objet

    const numDevis = getNumDemandeDevis(lastObjectDemandeDevis)

    try {
      const res = await validateSuggestion(
        ids,
        status,
        idMotif,
        clientId,
        isProspect,
        demandeId,
        isAdresseUpdated,
        adresseLivToSend,
        adresseFactToSend,
        null, // à revoir plus tard
        demandeClient?.contactedBy?.email,
        selectedDepotsByPiece,
        commentaireInterne,
        paymentIntentIds,
        sourceDevis,
        selectedOption,
        montantAPayer,
        numDevis,
        false,
        retraitDepot
      )
      if (adresseFactToSend?.edited || adresseLivToSend?.edited) {
        refetchClientAdresses(clientId)
      }
      const success = res && res.data && res.status === 200

      if (!success) {
        toast.update(idToastValidate, {
          render: 'Validation échouée',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
        return
      }

      // Mise à jour du panier
      const updatedPanier = panier.map((item) => {
        let updatedItem = {...item}

        if (ids.includes(item.idPiecePropose)) {
          if (isProspect || selectedOption === 'virement') {
            updatedItem.statut = 'BLOQU'
            updatedItem.isAccepted = false
            updatedItem.isAcceptedBlocked = true
          } else if (status && res?.data?.etapeCode === 'BLOQU') {
            if (updatedItem?.isTypePiecePOT === true || updatedItem?.isDemontage === true) {
              updatedItem.statut = 'BLOQU'
              updatedItem.isAccepted = false
              updatedItem.isAcceptedBlocked = true
            } else {
              updatedItem.statut = 'ACCEP'
              updatedItem.isAccepted = true
              updatedItem.isAcceptedBlocked = false
            }
          } else {
            updatedItem.statut = nouveauStatut
            if (status) {
              updatedItem.isAccepted = !isProspect
              updatedItem.isAcceptedBlocked = !!isProspect
            }
          }
          updatedItem.isQuantityReached =
            validCountByDemPiece[item.idCLientDemandePiece] >= item.pieceQuantity
        }
        return updatedItem
      })
      setPanier(updatedPanier)
      if (panierFiltered) panierFiltered(updatedPanier)

      // Mise à jour des statuts locaux
      setStatutsLocaux((prev) => {
        const updated = {...prev}
        ids.forEach((id) => {
          updated[id] =
            status && res?.data?.etapeCode === 'BLOQU'
              ? updatedPanier?.find((item) => item?.id === id)?.status
              : nouveauStatut
        })
        return updated
      })

      // Actualiser statut après action refus ou acceptation
      setPiecesProps((prevPieces) =>
        prevPieces.map((p) => ({
          ...p,
          clientDemandePieceProposee: p.clientDemandePieceProposee?.map((prop) =>
              ids.includes(prop.id) ? { ...prop, statut: nouveauStatut } : prop
          ),
          demande: {
            ...p.demande,
            clientDemandeEtape: {
              ...p.demande.clientDemandeEtape,
              code: nouveauStatut === 'ACCEPTE' ? 'ACCEP' : 'REFUS',
            },
          },
          demandeDemontage: p.demandeDemontage
              ? {
                ...p.demandeDemontage,
                statut: {
                  ...p.demandeDemontage.statut,
                  code: status ? 'VALIDE' : 'REFUS',
                },
              }
              : p.demandeDemontage,
        }))
      )

      // Actualiser statut demande
      // const nouveauCode = res.data.etapeCode
      // setDemandeClient((prev) => ({
      //   ...prev,
      //   clientDemandeEtape: {
      //     ...prev.clientDemandeEtape,
      //     code: nouveauCode,
      //     libelle: statutLabels[nouveauCode] ?? 'Inconnu',
      //   },
      // }))
      if (res.data?.clientDemande) {
        setDemandeClient(res.data?.clientDemande)
      }

      setCheckedPieces([])
      toast.update(idToastValidate, {
        render: 'Validation effectuée avec succès',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      })

      getDemandeProp() // Recharger le panier pour éviter le bug liée à l'assoçiation libelle <-> pièce
    } catch (error) {
      console.error(error)
      toast.update(idToastValidate, {
        render: "Une erreur s'est produite",
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      })
    } finally {
      setDisableBtn(false)
    }
  }

  const cancelProposition = (ids: any) => {
    let nouveauStatut: string = 'CANCE'
    const nowIso = new Date().toISOString()
    let nomsPieces = panier
        .filter((item) => ids.includes(item.idPiecePropose))
        .map((item) => item?.nomTypePieceProposee)
    const piecesString: string = Array.from(new Set(nomsPieces)).join(", ").toLowerCase();

    Swal.fire({
      title: 'Attention',
      text: 'Voulez-vous vraiment annuler la ou les pièces suivante(s) : ' + piecesString + ' .',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        const idToastValidate = toast.loading('Annulation en cours...')
        setDisableBtn(true)
        cancelPieces(ids).then((res) => {
          if (res?.data && res.status === 200) {
            getDemandeProp() // Recharger le panier pour éviter le bug liée à l'assoçiation libelle <-> pièce

            setStatutsLocaux((prev) => {
              const updated = {...prev}
              ids.forEach((id) => {
                updated[id] = nouveauStatut
              })
              return updated
            })
            setDateAnnulationLocaux((prev) => {
              const updatedDate = {...prev}
              ids.forEach((id) => {
                updatedDate[id] = nowIso
              })
              return updatedDate
            })
            const updatedPanier = panier.map((item) =>
                ids.includes(item.idPiecePropose)
                    ? {...item, statut: nouveauStatut, dateAnnulation: nowIso}
                    : item
            )
            //debut actualisation statut apres annulation
            setPiecesProps((prevPieces) =>
                prevPieces.map((p) => ({
                  ...p,
                  clientDemandePieceProposee: p.clientDemandePieceProposee?.map((prop) =>
                      ids.includes(prop.id) && !prop.dateAnnulation
                          ? {...prop, dateAnnulation: nowIso}
                          : prop
                  ),
                }))
            )
            //fin actualisation statut apres annulation

            setPanier(updatedPanier)

            const futureAnnules = Array.from(new Set([...idsAnnules, ...ids]))
            // Filtrer les pièces non annulées et recalculer le total proposé
            const panierActif = panier.filter((item) => !futureAnnules.includes(item.idPiecePropose))
            setTotalPropose(calculerTotal(panierActif, 'TotalPropose').toFixed(2))
            setTotalFraisPort(calculerTotal(panierActif, 'FraisPort').toFixed(2))
            setTotalProposeHT(calculerTotal(panierActif, 'TotalProposeHT').toFixed(2))
            setTotalProposeTTC(calculerTotal(panierActif, 'TotalProposeTTC').toFixed(2))
            setIdsAnnules(futureAnnules)

            setCheckedPieces([])
            setDisableBtn(false)
            if (redirectDemandeListPage) {
              toast.update(idToastValidate, {
                render: 'Annulation effectuée avec succès',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
              navigate(`/demandes/liste`, {
                state: {
                  redirectToClientDemande: redirectToClientDemande,
                  filters: filters,
                },
              })
            } else {
              toast.update(idToastValidate, {
                render: 'Annulation effectuée avec succès',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
            }

            let idClientDemande = demandeId
            let commentaire = `Annulation des propositions: ${nomsPieces.join(', ')}`
            const nouveauCommentaire: ModeleCommentaireClientDemande = {
              idClientDemande,
              message: commentaire,
              description: commentaire,
              auteur: currentUser?.nom ?? currentUser?.pseudo,
            }
            try {
              createCommentaireClientDemande(nouveauCommentaire)
            } catch (err) {
              console.error("Erreur lors de l'envoi du commentaire", err)
            }
          } else {
            toast.update(idToastValidate, {
              render: "Une erreur s'est produite",
              type: 'error',
              isLoading: false,
              autoClose: 3000,
            })
          }
        })
      }
    })

  }

  useEffect(() => {
    if (!panier) return

    const unvalidatedIds = panier
      .filter((item) => {
        const checkQuantiteMax =
          validCountByDemPiece[item.idCLientDemandePiece] >= item.pieceQuantity
        return (
          item.statut === 'PROPO' &&
          statutsLocaux[item.idPiecePropose] !== 'CANCE' &&
          statutsLocaux[item.idPiecePropose] !== 'REFUS' &&
          statutsLocaux[item.idPiecePropose] !== 'ACCEP' &&
          statutsLocaux[item.idPiecePropose] !== 'BLOQU' &&
          !checkQuantiteMax
        )
      })
      .map((item) => item.idPiecePropose)

    const allSelected =
      unvalidatedIds.length > 0 &&
      checkedPieces.length === unvalidatedIds.length &&
      unvalidatedIds.every((idPiecePropose) => checkedPieces.includes(idPiecePropose))

    const prevPanier = [...panier]
    setPiecesProposeesChecked(
      prevPanier.filter((piece) => checkedPieces.includes(piece.idPiecePropose))
    )

    setIsAllSelected(allSelected)
  }, [checkedPieces, panier])

  useEffect(() => {
    if (!panier) return
    const nonValide = panier.filter(
      (item) =>
        item.statut === 'PROPO' &&
        statutsLocaux[item.idPiecePropose] !== 'CANCE' &&
        statutsLocaux[item.idPiecePropose] !== 'REFUS' &&
        statutsLocaux[item.idPiecePropose] !== 'ACCEP' &&
        statutsLocaux[item.idPiecePropose] !== 'BLOQU' &&
        !(validCountByDemPiece[item.idCLientDemandePiece] >= item.pieceQuantity)
    )
    setShowAllSelect(nonValide.length > 0)
  }, [panier, statutsLocaux])

  // Gestion de la liste des pièces recherchées de la demande
  const handleGetStock = (e, p) => {
    e.preventDefault()

    // Désactivation des liens pour les quantités atteintes et sur la même page
    if (
      (idPiecePropose === p.id && location.pathname.includes('enStock')) ||
      p.proposee === p.quantite
    )
      return

    if (modalRef.current) {
      const modal = Modal.getInstance(modalRef.current)
      modal?.hide()
    }

    // const filteredPcs = pieces.filter((pc: any) => pc.id == p.id)
    const filteredPcs = pieces.filter(
      (pc: any) => pc?.clientDemandeImmat?.id == p?.clientDemandeImmat?.id
    )
    const states = {
      immatriculation: p.clientDemandeImmat.modele
        ? p.clientDemandeImmat.modele.id
        : p.clientDemandeImmat?.vehiculeHorsType
        ? p.clientDemandeImmat?.vehiculeHorsType.id
        : p.clientDemandeImmat?.immatriculation,
      quantity: p?.quantite - (p?.proposee ?? 0),
      clientId: p.demande?.client?.id,
      demandeId: p.demande?.id,
      // panier: panier,
      demandeImmatId: p.clientDemandeImmat?.id,
      redirectToClientDemande: redirectToClientDemande,
      refConst: p.referenceConstructeur,
      marque: p.marque,
      modele: p.modele,
      pieceQuantity: p?.quantite,
      idModele: p?.clientDemandeImmat?.modele?.id,
      isViaModele: !!p?.clientDemandeImmat?.modele?.id,
      isHorsType: !!p?.clientDemandeImmat?.vehiculeHorsType?.id,
      idPiecePropose: p?.id,
      dataClientInfos: dataClientInfos,
      otherData: otherData,
      loadingCLientInfo: loadingCLientInfo,
      pieces: pieces,
      piece: p,
      selectedPiecesFromVehicle: filteredPcs,
      isAvailable: filteredPcs[0].statut !== 'NON_DISPONIBLE',
      typePieceHnFiltered: p?.typePieceHn,
      typePieceFiltered: p?.typePiece ?? null,
      isFromUrlFiltered: true,
      isHorsNomenclature: !!p?.typePieceHn,
      idDemandePiece: p?.id,
      isAssign: true,
      demandeClient: demandeClient,
      fromListePieceStock: true,
      clientAdresses: clientAdresses,
      clientDemandeStatus: clientDemandeStatus,
    }
    navigate(`/demandes/${p?.clientDemandeImmat?.id}/enStock/`, {
      state: {
        ...states,
        filters,
      },
    })
  }

  // Pour détecter l'état du modal (pour réinitialiser le bouton "Afficher ou masquer les pièces recherchées")
  useEffect(() => {
    const modal = modalRef.current

    if (modal) {
      modal.addEventListener('hidden.bs.modal', () => {
        setIsModalOpen(false)
      })

      modal.addEventListener('shown.bs.modal', () => {
        setIsModalOpen(true)
      })
    }

    // Nettoyer l'event listener quand le composant se démonte
    return () => {
      if (modal) {
        modal.removeEventListener('hidden.bs.modal', () => {})
        modal.removeEventListener('shown.bs.modal', () => {})
      }
    }
  }, [])

  useEffect(
    function hideClientInfosOnModalClose() {
      if (!isModalOpen) setShowMoreClientInfo(false)
    },
    [isModalOpen]
  )

  // Filtre du panier par rapport au selecteur
  useEffect(() => {
    let filteredData = panier;

    if (panier?.length > 0 && activeFiltrePanier?.value) {
      if (activeFiltrePanier?.value === 'Tous') {
        filteredData = panier;
      } else if (activeFiltrePanier?.value === 'En cours') {
        filteredData = panier?.filter((item) => item?.statut === 'PROPO' || item?.statut === 'A_PROPO' || item?.statut === 'ACCEP') ?? [];
      } else if (activeFiltrePanier?.value !== 'Tous' || activeFiltrePanier?.value !== 'En cours') {
        const historiquePanier = historiqueDevis
          ?.filter((item) => item?.id === activeFiltrePanier?.value)
          ?.flatMap((item) => item?.panier)
          ?.map((item) => item?.id) ?? []
        filteredData = panier?.filter((item) => historiquePanier?.includes(item?.id)) ?? [];
      } else filteredData = panier;

      setFilteredPanier(filteredData);
    }

    setTotalPropose(calculerTotal(filteredData, 'TotalPropose').toFixed(2))
    setTotalFraisPort(calculerTotal(filteredData, 'FraisPort').toFixed(2))
    setTotalProposeHT(calculerTotal(filteredData, 'TotalProposeHT').toFixed(2))
    setTotalProposeTTC(calculerTotal(filteredData, 'TotalProposeTTC').toFixed(2))
  }, [panier, retraitDepot, dataClientInfos, activeFiltrePanier])

  // Filtre des libellés par rapport au selecteur
  useEffect(() => {
    let filteredData = libelleList;

    if (libelleList?.length > 0) {
      if (activeFiltrePanier?.value === 'Tous') {
        filteredData = libelleList;
      } else if (activeFiltrePanier?.value === 'En cours') {
        let preparedPanier = panier
          ?.filter((item) => item?.statut === 'PROPO' || item?.statut === 'A_PROPO' || item?.statut === 'ACCEP')
          .map((item) => item?.idPiecePropose) ?? [];
        filteredData = libelleList.filter((item) =>
          preparedPanier?.includes(item?.clientDemandePieceProposee?.id)
          || item?.clientDemandePieceProposee === null
        );
      } else if (activeFiltrePanier?.value !== 'Tous' || activeFiltrePanier?.value !== 'En cours') {
        // const historiquePanier = historiqueDevis
        //   ?.filter((item) => item?.id === activeFiltrePanier?.value)
        //   ?.flatMap((item) => item?.libelle)
        //   ?.map((item) => item?.id) ?? []
        // filteredData = libelleList?.filter((item) => historiquePanier?.includes(item?.id)) ?? [];
        filteredData = historiqueDevis
          ?.filter((item) => item?.id === activeFiltrePanier?.value)
          ?.flatMap((item) => item?.libelle) ?? [];
      } else filteredData = libelleList;

      setFilteredLibelle(filteredData);
    }

    const totalLibelle = filteredData.reduce((total, item) => total + item.quantite * item.prixUnitaire, 0)
    // Frais de port est en HT depuis le libelle frais de port dans le panier
    setTotalLibelle(Number(totalLibelle))
    // TVA frais de port toujours 20%
    setTotalLibelleTTC(Number(Number(totalLibelle) * (1 + 20 / 100)))
  }, [libelleList, panier, activeFiltrePanier]);

  // Enregistrement de l'identifiant de la demande et du panier dans le localStorage
  useEffect(() => {
    const panierStorage = localStorage.getItem('panier')

    // Si le panier est vide
    if (panier.length === 0) {
      // Si il y a des données dans le localStorage
      if (panierStorage !== null) {
        const demandeIdStorageValue = JSON.parse(panierStorage)[0]
        const panierStorageValue = JSON.parse(panierStorage)[1]

        // Si l'identifiant de la demande n'est pas null et est égal à l'identifiant de la demande en props
        if (demandeIdStorageValue !== null && parseInt(demandeIdStorageValue) === demandeId) {
          setPanier(panierStorageValue)
        } else {
          localStorage.removeItem('panier')
        }
      }
    } else {
      localStorage.setItem('panier', JSON.stringify([Number(demandeId), panier]))
    }
  }, [nouveauPanier])

  useEffect(() => {
    //  Sauvegarde / suppression du localStorage quand le panier change
    if (panier.length > 0) {
      localStorage.setItem('panier', JSON.stringify([Number(demandeId), panier]))
    } else {
      localStorage.removeItem('panier')
    }
  }, [panier, demandeId])

  // Récupération des type de libellé
  const getTypeLibelleDemande = () => {
    setSpinnerLibelle(true)
    return getAllTypeLibelleDemande().then((res) => {
      if (res?.status === 200 && res?.data !== undefined) {
        setAllTypeLibelleDmd(res?.data)
        setSpinnerLibelle(false)
      }
    })
  }

  useEffect(() => {
    if (loading || loadingPanier || !demandeId) return
    getTypeLibelleDemande()
    getAllLibelleDemande()
  }, [demandeId, loading, loadingPanier])

  // Switch entre pièce et libellé
  const handleSwitchPieceDevis = () => {
    setSwitchPiece(!switchPiece)
  }

  const handlePutDevis = (devis) => {
    setShowForm(true)
    setShowEditForm(null)

    setSwitchPiece(false)
    setLibelleForm({
      id: devis.id,
      code: devis.code,
      commentaire: devis.commentaire,
      quantite: '',
      prixUnitaire: '',
    })
  }

  // UseEffect pour vérifier et mettre à jour la ref de libelleList par rapport au dernier devis
  useEffect(() => {
    if (!historiqueDevis) return

    if (historiqueDevis?.[0]?.libelle?.length > 0) {
      initialLibellesRef.current = historiqueDevis?.[0]?.libelle
    }

    setHasLibelleChanged(!isEqual(libelleList, initialLibellesRef.current))
  }, [libelleList, historiqueDevis])

  // Récupération des libellés liées à la demande
  const getAllLibelleDemande = (isRefetch: boolean = false) => {
    setSpinnerLibelleDisplay(true)
    getLibelleDemandePiece(demandeId).then((res) => {
      if (res?.status === 200) {
        setLibelleList(res.data)

        if (initialLibellesRef.current === null && !isRefetch) {
          initialLibellesRef.current = structuredClone(res.data)
        }

        setReloadLibelle(false)
      } else {
        toast.error('Erreur lors de la récupération des libellées')
        setReloadLibelle(false)
      }
      setSpinnerLibelleDisplay(false)
      setFullLibelleData(true)
    })
  }

  useEffect(function refetchLibelle() {
    if (!reloadLibelle || loading || loadingPanier || !demandeId) return

    getAllLibelleDemande()
  }, [reloadLibelle, loading, loadingPanier, demandeId])

  useEffect(() => {
    if (!panier || piecesProposeesModifiees.length > 0) return

    const piecePanier = panier?.map((item) => ({
      value: item.idPiecePropose,
      label: item?.nomTypePieceProposee + ' [' + item?.refConstructeur + ']',
      idRetraitDepot: item?.idRetraitDepot ?? null,
      nomRetraitDepot: item?.nomRetraitDepot ?? null,
      disabled: !(item?.statut === 'PROPO' || item?.statut === 'A_PROPO'), // si statut pièce PROPO/A_PROPO => disabled= false sinon true
    }))
    const transformedPiecePanier = [{value: 'tous', label: 'Tous'}, ...piecePanier]
    setPiecePanierFormat(transformedPiecePanier)
  }, [panier, piecesProposeesModifiees])

  useEffect(() => {
    if (!adresseDepots?.length) return

    // Insertion de la valeur vide
    const transformedDataAdresseDepot = [
      {value: null, label: ''},
      ...(adresseDepots ?? [])?.map((item) => ({
        value: item.id,
        label: item?.nom,
      }))
    ]
    // Selection de la valeur vide par défaut
    setSelectedDepot(transformedDataAdresseDepot?.[0])
    setAddressDepotFormat(transformedDataAdresseDepot)
  }, [adresseDepots])

  // Affichage total de dévis
  const renderTotaux = () => {
    const ht = Number(totauxDevis).toFixed(2) || 0
    const ttc = Number(totauxDevisTTC).toFixed(2) || 0
    const tva = (Number(ttc) - Number(ht)).toFixed(2)
    return (
      <div className='d-flex align-items-center gap-12 text-gray-700 fw-semibold'>
        {dataClientInfos?.professionnel && (
          <div className='d-flex flex-column'>
            <div className='text-muted fs-6'>Total HT</div>
            <div className='fs-3 text-end fw-bold h-20px'>{ht} €</div>
          </div>
        )}
        {dataClientInfos?.professionnel && (
          <div className='d-flex flex-column'>
            <div className='text-muted fs-6'>TVA</div>
            <div className='fs-3 text-end fw-bold h-20px'>{tva} €</div>
          </div>
        )}
        <div className='d-flex flex-column'>
          <div className='text-muted fs-6'>Total TTC</div>
          <div className='fs-3 text-end fw-bold h-20px'>{ttc} €</div>
        </div>
      </div>
    )
  }

  const handleModalDismiss = () => {
    // handleDismiss?.()
    // Configurer l'ouverture du panier sur les filtres de pièces par statut
    if (fromListePieceStock) return
    setFromListePiece(false)
  }

  const getAllClientAdresses = () => {
    setClientAdresses(null)
    setUpdatedFinalAdresseFactInfo(null)
    setUpdatedFinalAdresseLivInfo(null)
    setLoadingAdresse(true)
    getClientAdresses(clientId).then((res) => {
      if (res.status === 200) {
        setClientAdresses(res.data)
        setLoadingAdresse(false)
      }
    })
  }

  useEffect(
    function fetchClientAdresses() {
      if (location.pathname === `/demandes/${clientId}/traitement/${demandeId}`) {
        setClientAdresses(clientAdressesFacLiv)
      } else {
        if (clientId) {
          getAllClientAdresses()
        }
      }
    },
    [clientId, clientAdressesFacLiv]
  )

  useEffect(
    function getDefaultAdressFacturation() {
      const filteredData = clientAdresses?.filter((adresse) => adresse?.facturation === true)
      setFilteredAdresseFacturation(filteredData?.[0])
    },
    [clientAdresses]
  )

  // Pour stocker le contenu du mail à envoyer lors d'une modification
  const handleEmailContentChange = (value: string, index: string) => {
    setMailContent((prev) => ({
      ...prev,
      [index]: value,
    }))
  }

  useEffect(() => {
    getObjetOfCheckedPiece(checkedPieces)
  }, [checkedPieces])

  const getObjetOfCheckedPiece = (idCheckedPiece) => {
    const pieceObj = panier?.filter((pan) => idCheckedPiece.includes(pan?.idPiecePropose))
    setPieceCheckedObj(pieceObj)
  }

  useEffect(
    function setDefaultDepotAddressForPiece() {
      if (!adresseDepots?.length) return

      if (retraitDepot) {
        const lastAdress = adresseDepots[adresseDepots.length - 1]

        // Ne garder que les pièces cochées
        const checkedIds = new Set(pieceCheckedObj.map((pc) => pc?.idPiecePropose))

        setSelectedDepotsByPiece((prev) => {
          const updated: Record<string, string> = {}

          // On ne garde que les entrées correspondant à des pièces encore cochées
          Object.keys(prev).forEach((idPiece) => {
            if (checkedIds.has(idPiece)) {
              updated[idPiece] = prev[idPiece]
            }
          })

          // On ajoute le dépôt par défaut pour les nouvelles pièces cochées
          // pieceCheckedObj.forEach((pc) => {
          //   if (updated[pc?.idPiecePropose] === undefined) {
          //     updated[pc?.idPiecePropose] = lastAdress?.id
          //   }
          // })

          pieceCheckedObj.forEach((pc) => {
            if (updated[pc?.idPiecePropose] === undefined) {
              const associationPiece = associations[pc?.idPiecePropose]
              updated[pc?.idPiecePropose] =
                associationPiece?.depotId !== undefined && associationPiece?.depotId !== null
                  ? associationPiece.depotId
                  : lastAdress?.id
            }
          })

          return updated
        })
      } else {
        setSelectedDepotsByPiece({})
      }
    },
    [pieceCheckedObj, adresseDepots, retraitDepot, associations]
  )

  // Utile si en cas de changement d'adresse fact/liv dans Modal Paiement
  useEffect(
    function updatePendingValidationParamsRef() {
      if (pendingValidationParams.current) {
        pendingValidationParams.current.adresseFactToSend = updatedFinalAdresseFactInfo
        pendingValidationParams.current.adresseLivToSend = updatedFinalAdresseLivInfo
      }
    },
    [updatedFinalAdresseFactInfo, updatedFinalAdresseLivInfo]
  )

  const handleSelectedDepotPiece = (idDepot, idPiecePropose) => {
    setSelectedDepotsByPiece((prev) => ({
      ...prev,
      [idPiecePropose]: idDepot,
    }))
  }

  // Fonction déclencher via submit dans modal de paiement
  const finalValidation = async (e: React.FormEvent) => {
    e?.preventDefault() // bloque le rechargement de la page
    const params = pendingValidationParams.current

    if (!params) return

    const {ids, status, idMotif, isProspect, nouveauStatut, adresseFactToSend, adresseLivToSend} =
      params

    suggestionValidation(
      ids,
      status,
      idMotif,
      isProspect,
      nouveauStatut,
      adresseLivToSend,
      adresseFactToSend,
      commentaireInterne
    )
  }

  // Séléction de l'adresse de facturation
  const handleSelectedFactChange = (e) => {
    const adresseFacturation = clientAdresses?.filter((adresse) => adresse.facturation === true)

    const selectAdresse = adresseFacturation?.find((adresse) => adresse.id === e.value)
    setFacturationSelectedValue(transformToValueLabel(selectAdresse))

    if (!setUpdatedFinalAdresseFactInfo) return

    setUpdatedFinalAdresseFactInfo({
      id: selectAdresse?.id || '',
      adresseFac: selectAdresse?.adresse || '',
      complementAdresseFac: selectAdresse?.complementAdresse || '',
      telephoneFac: selectAdresse?.telephone || '',
      cPFac: selectAdresse?.codePostal || '',
      villeFac: selectAdresse?.ville || '',
      paysFac: selectAdresse?.pays?.nom || '',
    })
  }

  // Séléction de l'adresse de livraison
  const handleSelectedLivChange = (e) => {
    const adresseLivraison = clientAdresses?.filter((adresse) => adresse.livraison === true)

    const selectAdresse = adresseLivraison?.find((adresse) => adresse.id === e.value)
    setLivraisonSelectedValue(transformToValueLabel(selectAdresse))

    if (!setUpdatedFinalAdresseLivInfo) return

    setUpdatedFinalAdresseLivInfo({
      id: selectAdresse?.id || '',
      adresseLiv: selectAdresse?.adresse || '',
      complementAdresseLiv: selectAdresse?.complementAdresse || '',
      telephoneLiv: selectAdresse?.telephone || '',
      cPLiv: selectAdresse?.codePostal || '',
      villeLiv: selectAdresse?.ville || '',
      paysLiv: selectAdresse?.pays?.nom || '',
    })
  }

  useEffect(
    function addClientParametrage() {
      setClientParametrage(dataClientInfos?.parametrage)
    },
    [dataClientInfos]
  )

  useEffect(function attributeSourceDevis() {
    const {isAuto, isMoto, isIndus, source} = computeSource(utilisateurAssigne, dataClientInfos)
    if (isAuto) setSourceDevis('AUTO')
    if (isMoto) setSourceDevis('MOTO')
    if (isIndus) setSourceDevis('INDUSTRIE')
  }, [])

  return (
    <>
      {displayBasket && (
        <div className='text-end'>
          <button
            type='button'
            className='btn btn-light-info border border-info d-flex gap-4 align-items-center'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
            onClick={handleModalDismiss}
          >
            <i className='bi bi-cart2' style={{fontSize: '20px'}}></i>
            Voir le panier{' '}
            {totalPanier == 0 || totalPanier == undefined ? '' : '(' + totalPanier + ')'}
          </button>
        </div>
      )}
      <div
        className='modal fade'
        tabIndex={-1}
        id='kt_modal_1'
        ref={modalRef}
        aria-hidden={!isModalOpen}
      >
        <div className='modal-dialog' style={{maxWidth: '1750px', width: '95%'}}>
          <div className='modal-content'>
            <div className='modal-header py-3 pb-2'>
              <div>
                <h5 className='modal-title my-2'>Constitution de la proposition</h5>
              </div>
              {/*Bloc information demande*/}
              <DemandeInfos demandeId={demandeId} demandeClient={demandeClient} fromModal={true} />
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            {loadingCLientInfo ? (
              <LoadingData />
            ) : (
              <>
                <ClientInfos
                  clientData={dataClientInfos}
                  demandeId={demandeId}
                  otherData={otherData}
                  loadingCLientInfo={loadingCLientInfo}
                  isProspect={isProspect}
                  displaySuggestion={true}
                  clientAdresses={null}
                  contactedBy={null}
                  fromModal={true}
                  changeClientOnShop={true}
                  setIsEdit={setIsEdit}
                  fromListDemande={fromListDemande}
                  clientDemandeStatus={clientDemandeStatus}
                />
                {/*Affichage "Plus d'informations"*/}
                <ClientMoreInfos
                  otherData={otherData}
                  demandeId={demandeId}
                  demandeClient={demandeClient}
                  clientData={dataClientInfos}
                  isConfirmEdit={isConfirmEdit}
                  contactedBy={contactedBy}
                  contactedByBloc={contactedByBloc}
                  setContactedByBloc={setContactedByBloc}
                  contentCommunication={''}
                  fromListDemande={fromListDemande}
                  groupeClientLoader={groupeClientLoader}
                  showMoreClientInfo={showMoreClientInfo}
                  setShowMoreClientInfo={setShowMoreClientInfo}
                />
                {/*Affichage "Adresse Facturation/Livraison"*/}
                <FinalAdresseClient
                  clientAdresses={clientAdresses}
                  setClientAdresses={setClientAdresses}
                  isAdresseUpdated={isAdresseUpdated}
                  setIsAdresseUpdated={setIsAdresseUpdated}
                  updatedFinalAdresseLivInfo={updatedFinalAdresseLivInfo}
                  setUpdatedFinalAdresseLivInfo={setUpdatedFinalAdresseLivInfo}
                  updatedFinalAdresseFactInfo={updatedFinalAdresseFactInfo}
                  setUpdatedFinalAdresseFactInfo={setUpdatedFinalAdresseFactInfo}
                  loadingAdresse={loadingAdresse}
                  clientData={dataClientInfos}
                  errorsFac={errorsFac}
                  errorsLiv={errorsLiv}
                  retraitDepot={retraitDepot}
                  setRetraitDepot={setRetraitDepot}
                  setPanier={setPanier}
                  setInitialPieces={setInitialPieces}
                  loadingDepot={loadingDepot}
                  handleSelectedFactChange={handleSelectedFactChange}
                  handleSelectedLivChange={handleSelectedLivChange}
                  addressDepotFormat={addressDepotFormat}
                  piecePanierFormat={piecePanierFormat}
                  associations={associations}
                  setAssociations={setAssociations}
                  selectedPiece={selectedPiece}
                  setSelectedPiece={setSelectedPiece}
                  selectedDepot={selectedDepot}
                  setSelectedDepot={setSelectedDepot}
                  livraisonSelectedValue={livraisonSelectedValue}
                  setFacturationSelectedValue={setFacturationSelectedValue}
                  facturationSelectedValue={facturationSelectedValue}
                  setLivraisonSelectedValue={setLivraisonSelectedValue}
                  clientAdresseData={clientAdresseData}
                />
              </>
            )}

            {/*<hr className='m-0 border-gray-300' />*/}

            <div className='mx-5 row mt-5'>
              <Tooltip id='tooltip-link' />
              {pieces?.length > 0 &&
                pieces?.map((p, i) => {
                  const inPan = panier?.filter(
                    (i) =>
                      i?.demandeImmatId === p?.clientDemandeImmat?.id &&
                      i?.idTypePiece === p?.typePiece?.id
                  ).length
                  return (
                    <div className='col'>
                      <li
                        className={`text-decoration-none mb-2 badge ${
                          idPiecePropose == p?.id ? 'badge-light-info' : 'badge-light'
                        }`}
                        key={i}
                      >
                        <Link
                          to={'#'}
                          className={idPiecePropose == p?.id ? `fw-bold text-info` : `text-muted`}
                          onClick={(e) => handleGetStock(e, p)}
                          data-tooltip-id='tooltip-link'
                          data-tooltip-content={
                            p.statut
                              ? 'Pièce non disponible'
                              : p.quantite === p.proposee
                              ? 'Quantité maximum atteinte'
                              : `${p.proposee}/${p.quantite} proposée(s)`
                          }
                          data-tooltip-place='right'
                        >
                          {p.typePiece ? p.typePiece?.nom : p.typePieceHn} [
                          {p.clientDemandeImmat?.immatriculation ?? `${p.marque} - ${p.modele}`}] (
                          {inPan})
                        </Link>
                      </li>
                    </div>
                  )
                })}
            </div>
            <div className={'modal-body pb-0'}>
              <div className={'d-flex justify-content-between'}>
                <div>
                  <h4>Libellés pré-enregistrés:</h4>
                  <div className={'d-flex gap-5 mt-5'}>
                    {spinnerLibelle ? (
                      <div className='d-flex gap-3 align-items-center text-muted'>
                        <span>Chargement des libellés...</span>
                        <div className='py-3'>
                          <span className='spinner-border spinner-border-sm align-middle ms-2 w-20px h-20px'></span>
                        </div>
                      </div>
                    ) : (
                      <>
                        {allTypeLibelleDmd.map((item, index) => {
                          const hasMatchIdTypeLibelle =
                            filteredLibelle.length > 0 &&
                            filteredLibelle.some((lib) => lib.typeLibelleDemande?.id === item?.id)

                          return (
                            <div className='position-relative'>
                              <button
                                key={item.id}
                                className={'btn btn-sm btn-light-primary'}
                                onClick={() => handlePutDevis(item)}
                              >
                                {item.code}
                              </button>
                              {hasMatchIdTypeLibelle && (
                                <span
                                  className='badge badge-circle badge-warning position-absolute h-10px w-10px'
                                  style={{
                                    top: '-5px',
                                    right: '-5px',
                                  }}
                                ></span>
                              )}
                            </div>
                          )
                        })}
                      </>
                    )}
                  </div>
                </div>
                <div>
                  <div>
                    {!spinnerLibelle && (
                      <div className='d-flex justify-content-end'>
                        <div className='form-check form-switch form-check-custom form-check-solid'>
                          <label
                            className={`form-check-label cursor-pointer px-3 ${
                              switchPiece && 'text-primary'
                            }`}
                            htmlFor='flexSwitchChecked'
                          >
                            Pièce
                          </label>
                          <input
                            className='form-check-input h-20px w-30px cursor-pointer'
                            type='checkbox'
                            value=''
                            id='flexSwitchChecked'
                            onClick={() => handleSwitchPieceDevis()}
                            checked={!switchPiece}
                          />
                          <label
                            className={`form-check-label cursor-pointer ${
                              !switchPiece && 'text-primary'
                            }`}
                            htmlFor='flexSwitchChecked'
                          >
                            Libellé
                          </label>
                        </div>
                      </div>
                    )}

                    <div className='mt-5 min-w-300px'>
                      <Select
                        className='react-select-styled react-select-solid react-select-lg'
                        classNamePrefix='react-select'
                        options={filtrePanier}
                        fieldName='filtrePanier'
                        value={activeFiltrePanier}
                        onChange={(value) => setActiveFiltrePanier(value)}
                        placeholder={''}
                        formatOptionLabel={(option) => (
                          <div>
                            <div>{option?.label}</div>
                            {option?.dateCreation && (
                              <div className='text-muted'>{moment(option.dateCreation).format('DD-MM-YYYY hh:mm:ss')}</div>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/*Affichage entre piece et libellée*/}
              {switchPiece ? (
                <ShopPiece
                  showAllSelect={showAllSelect}
                  isAllSelected={isAllSelected}
                  setIsAllSelected={setIsAllSelected}
                  panier={filteredPanier}
                  setPanier={setPanier}
                  setCheckedPieces={setCheckedPieces}
                  statutsLocaux={statutsLocaux}
                  loading={loading}
                  loadingPanier={loadingPanier}
                  nouveauPanier={nouveauPanier}
                  checkedPieces={checkedPieces}
                  setDataToDisplay={setDataToDisplay}
                  initialPieces={initialPieces}
                  setPiecesProposesModifiees={setPiecesProposesModifiees}
                  panierFiltered={panierFiltered}
                  dateAnnulationLocaux={dateAnnulationLocaux}
                  setNouveauPanier={setNouveauPanier}
                  setPiecesProps={setPiecesProps}
                  setPieces={setPieces}
                  piecesInStockArr={piecesInStockArr}
                  setPiecesInStockArr={setPiecesInStockArr}
                  piecesInStockArrTemp={piecesInStockArrTemp}
                  totalPropose={totalPropose}
                  totalFraisPort={totalFraisPort}
                  checkDisponibilite={checkDisponibilite}
                  validCountByDemPiece={validCountByDemPiece}
                  statutLabels={statutLabels}
                  fromListePiece={fromListePiece}
                  panierByStatus={panierByStatus}
                  setPanierByStatus={setPanierByStatus}
                  provenances={provenances}
                  isLoadingProvenance={isLoadingProvenance}
                  dataClientInfos={dataClientInfos}
                  retraitDepot={retraitDepot}
                  setAssociations={setAssociations}
                  setIsEditPanier={setIsEditPanier}
                  demandeId={demandeId}
                  setDemandeClient={setDemandeClient}
                  setLibelleList={setLibelleList}
                />
              ) : (
                <ShopLibelle
                  libelleForm={libelleForm}
                  setLibelleForm={setLibelleForm}
                  demandeId={demandeId}
                  libelleList={filteredLibelle}
                  getAllLibelleDemande={getAllLibelleDemande}
                  spinnerLibelleDiplay={spinnerLibelleDiplay}
                  showForm={showForm}
                  setShowForm={setShowForm}
                  totalLibelle={totalLibelle}
                  panier={panier}
                  setHasLibelleChanged={setHasLibelleChanged}
                  showEditForm={showEditForm}
                  setShowEditForm={setShowEditForm}
                />
              )}
              <div
                className={`d-flex justify-content-between align-items-center p-6 ${
                  !(loading || loadingPanier) ? 'border rounded mb-4' : ''
                } `}
              >
                <div>{!(loading || loadingPanier) && renderTotaux()}</div>
                <div>
                  {historiqueDevis && historiqueDevis?.length > 0 && (
                    <span
                      className='d-flex justify-content-between align-items-center text-primary gap-2 fs-5 cursor-pointer'
                      data-bs-toggle='modal'
                      data-bs-target='#kt_modal_devis'
                      onClick={() => setDisplayHistory(true)}
                    >
                      Voir les devis réalisés
                      <KTIcon iconName='arrow-right' className='text-primary fs-2' />
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className='modal-footer justify-content-between'>
              <div className='row align-items-center'>
                <div className='col-auto'>
                  <div className='d-flex justify-content-between align-items-center gap-3'>
                    <span>Commentaire interne</span>
                    <div
                      className='mt-2'
                      data-tooltip-id='tooltip-commentaire-interne'
                      data-tooltip-content={
                        'Indiquez vos commentaires liés à la préparation de commande si besoin (60 caractères maximum)'
                      }
                      data-tooltip-place='top'
                      data-tooltip-position-strategy='fixed'
                    >
                      <span className='ki-duotone ki-question-2 fs-5'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                        <span className='path3'></span>
                      </span>
                    </div>
                    <Tooltip
                      id='tooltip-commentaire-interne'
                      place='top'
                      positionStrategy='fixed'
                      middlewares={[offset(10), shift({padding: 5})]}
                    />
                    <input
                      type='text'
                      name='commentaireInterne'
                      className='form-control w-600px'
                      onChange={(e) => setCommentaireInterne(e?.target?.value ?? '')}
                      value={commentaireInterne ?? ''}
                      maxLength={60}
                      style={{height: '40px'}}
                    />
                  </div>
                  {/*<span*/}
                  {/*  className="text-muted float-end"*/}
                  {/*  style={{ fontSize: '11px' }}*/}
                  {/*>*/}
                  {/*  {commentaireInterne?.length ?? 0} / 60*/}
                  {/*</span>*/}
                </div>
              </div>
              <div>
                <div className='d-flex gap-3 justify-content-end'>
                  <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                    Fermer
                  </button>
                  {checkedPieces.length > 0 && !loadingDepot && (
                    <>
                      <button
                        className={`btn btn-primary ${disableBtn && 'disabled'}`}
                        onClick={() => {
                          if (!haveNoSelectedDepot) {
                            feedBackClient(checkedPieces, true, null)
                          } else toast.error('Veuillez sélectionner un point de dépôt')
                        }}
                      >
                        Accepter
                      </button>
                      <button
                        className={`btn btn-danger ${disableBtn && 'disabled'}`}
                        data-bs-toggle='modal'
                        data-bs-target='#kt_modal_refus'
                      >
                        Refuser
                      </button>
                      <button
                        type='button'
                        className={`btn btn-info ${disableBtn && 'disabled'}`}
                        onClick={() => cancelProposition(checkedPieces)}
                      >
                        Annuler
                      </button>
                    </>
                  )}
                  {/*Afficher le bouton si le panier contient une pièce modifiée*/}
                  {((piecesProposeesModifiees.length > 0) || haveUpdatedLibelle) && (
                    <button
                      type='button'
                      className={`btn btn-primary ${disableBtn && 'disabled'}`}
                      data-bs-toggle={!haveNoSelectedDepot ? 'modal' : undefined}
                      data-bs-target={!haveNoSelectedDepot ? '#kt_modal_devis' : undefined}
                      disabled={loadingRenvoiPropos}
                      onClick={() => {
                        if (!haveNoSelectedDepot) {
                          setOnResendPropo(true)
                          setDisplayHistory(false)
                          setOpenModalDevis(true)
                        } else toast.error('Veuillez sélectionner un point de dépôt')
                      }}
                    >
                      {!loadingRenvoiPropos && 'Renvoi de proposition'}
                      {loadingRenvoiPropos && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          Renvoi de proposition...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  )}
                  {piecesProposeesModifiees.length > 0 && (
                    <>
                      <button
                        type='button'
                        className={`btn btn-light-danger ${disableBtn && 'disabled'}`}
                        onClick={handleCancelRenvoiPropos}
                      >
                        Annuler renvoi
                      </button>
                    </>
                  )}
                  {/*Cacher le bouton si une pièce est à proposer et il n'y a aucun pièce déjà proposer*/}
                  {panier.length > 0 &&
                    panier.some((item) => item.statut === 'A_PROPO') &&
                    piecesProposeesModifiees.length == 0 && (
                      <button
                        type={'button'}
                        className={`btn btn-light-info ${
                          (loading || spinnerLibelle) && 'disabled'
                        }`}
                        data-bs-toggle={!haveNoSelectedDepot ? 'modal' : undefined}
                        data-bs-target={!haveNoSelectedDepot ? '#kt_modal_devis' : undefined}
                        disabled={piecesProposeesModifiees.length > 0}
                        onClick={() => {
                          if (!haveNoSelectedDepot) {
                            setOnResendPropo(false)
                            setDisplayHistory(false)
                            setOpenModalDevis(true)
                          } else toast.error('Veuillez sélectionner un point de dépôt')
                        }}
                      >
                        Générer le devis
                      </button>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*Modal pour séléctionner les motifs refus*/}
      <MotifModal
        selectedMotif={selectedMotif}
        setSelectedMotif={setSelectedMotif}
        pieceId={checkedPieces}
        handleStatus={feedBackClient}
      />

      {/*Modal pour afficher les infos de la pièce*/}
      <DetailsPieceModal dataSuggestion={dataToDisplay} isFromPanier={true} />

      {/*Modal pour afficher le devis*/}
      <ShopDevis
        libelleList={libelleList}
        setHasLibelleChanged={setHasLibelleChanged}
        panier={panier}
        dataClientInfos={dataClientInfos}
        demandeId={demandeId}
        pieces={pieces}
        setDisableBtn={setDisableBtn}
        clientId={clientId}
        setPanier={setPanier}
        redirectDemandeListPage={redirectDemandeListPage}
        redirectToClientDemande={redirectToClientDemande}
        demandeClient={demandeClient}
        setDemandeClient={setDemandeClient}
        setPiecesProps={setPiecesProps}
        setLoadStock={setLoadStock}
        fullLibelleData={fullLibelleData}
        otherData={fromListDemande ? mergedOtherData : otherData}
        filters={filters}
        onResendPropo={onResendPropo}
        setLoadingRenvoiPropos={setLoadingRenvoiPropos}
        piecesProposeesModifiees={piecesProposeesModifiees}
        setPiecesProposesModifiees={setPiecesProposesModifiees}
        setCheckedPieces={setCheckedPieces}
        piecesProposeesChecked={piecesProposeesChecked}
        setPiecesProposeesChecked={setPiecesProposeesChecked}
        adresseFacturation={fromListDemande ? filteredAdresseFacturation : adresseFacturation}
        historiqueDevis={historiqueDevis}
        loadingHistoryDevis={loadingHistoryDevis}
        displayHistory={displayHistory}
        updatedFinalAdresseLivInfo={updatedFinalAdresseLivInfo}
        updatedFinalAdresseFactInfo={updatedFinalAdresseFactInfo}
        setOpenModalDevis={setOpenModalDevis}
        openModalDevis={openModalDevis}
        setInitialPieces={setInitialPieces}
        mailContent={mailContent}
        onMailContentChange={handleEmailContentChange}
        retraitDepot={retraitDepot}
        getAdresseRetraitDepot={getAdresseRetraitDepot}
        commentaireInterne={commentaireInterne}
        setCommentaireInterne={setCommentaireInterne}
        associations={associations}
        activeHistorique={activeHistorique}
        setActiveHistorique={setActiveHistorique}
        clientContacts={clientContacts}
        isAdresseUpdated={isAdresseUpdated}
        setUpdatedAdresseLivInfo={setUpdatedAdresseLivInfo}
        setUpdatedAdresseFactInfo={setUpdatedAdresseFactInfo}
      />

      {/*Bouton qui simule l'ouverture du modal paiement*/}
      <button
        type={'button'}
        className={'d-none'}
        ref={openPaymentModal}
        data-bs-toggle='modal'
        data-bs-target='#modal_payment'
      ></button>

      {/*Modal de paiement final*/}
      <PaymentResumeModal
        isClientSide={false}
        updatedAdresseFactInfo={updatedFinalAdresseFactInfo}
        updatedAdresseLivInfo={updatedFinalAdresseLivInfo}
        setCheckedPieces={setCheckedPieces}
        pieces={pieceCheckedObj}
        total={total}
        setTotal={setTotal}
        totalLibelleFraisPort={retraitDepot ? 0 : totalLibelle}
        adresseDepots={retraitDepot ? adresseDepots : null}
        selectedDepotsByPiece={selectedDepotsByPiece}
        handleSelectedDepotPiece={handleSelectedDepotPiece}
        onValidate={finalValidation}
        retraitDepot={retraitDepot}
        clientAdresses={clientAdresses}
        handleSelectedFactChange={handleSelectedFactChange}
        handleSelectedLivChange={handleSelectedLivChange}
        facturationSelectedValue={facturationSelectedValue}
        setFacturationSelectedValue={setFacturationSelectedValue}
        livraisonSelectedValue={livraisonSelectedValue}
        setLivraisonSelectedValue={setLivraisonSelectedValue}
        dataClient={dataClientInfos}
        setRetraitDepot={setRetraitDepot}
        commentaireInterne={commentaireInterne}
        setCommentaireInterne={setCommentaireInterne}
        clientParametrage={clientParametrage}
        demandeId={demandeId}
        clientId={clientId}
        setSelectedOption={setSelectedOption}
        selectedOption={selectedOption}
        montants={montants}
        setMontants={setMontants}
        source={sourceDevis}
        onPaiementReussi={handlePaiementReussi}
      />

      <Tooltip id='tooltip' />
    </>
  )
}

export {ShopModal}
